import { render, staticRenderFns } from "./BaseBusiness.vue?vue&type=template&id=58d3a899&scoped=true&"
import script from "./BaseBusiness.vue?vue&type=script&lang=js&"
export * from "./BaseBusiness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d3a899",
  null
  
)

export default component.exports